import { render, staticRenderFns } from "./NumberOfFieldsChip.vue?vue&type=template&id=c8b45106&scoped=true&"
import script from "./NumberOfFieldsChip.vue?vue&type=script&lang=ts&"
export * from "./NumberOfFieldsChip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b45106",
  null
  
)

export default component.exports